import { GetPublicOrganizationResponse } from '../../types';
import { State } from './state-management/state';
import { getPublicOrganizationByDomain } from '../api/organization-api';
import { property } from './state-management/decorators/property';
import { state } from 'lit/decorators';

class UrlInfo extends State {
    @property({ type: Object }) urlOrganization?: GetPublicOrganizationResponse | null;

    @state() isReady: boolean = false;

    // call this in sign in page, and then in main-page. in main-page, check if data isReady, if not, instantiate
    async instantiateCustomUrlData() {
        this.isReady = false;

        // if the base url is not map.proxi.co or betamap.proxi.co, then we need to get the organization info
        const url = window.location.href;
        const urlParts = url.split('/');
        const baseUrl = urlParts[2].toLowerCase();
        // strip the port so localhost:8082 / 127.0.0.1:3000 match (no org has a localhost CNAME)
        const baseHost = baseUrl.split(':')[0];
        // Proxi's own hosts (map/play/demo/app/beta*, etc.) and local dev never have a custom-domain org — skip the lookup.
        const isProxiHost = baseHost === 'proxi.co' || baseHost.endsWith('.proxi.co');
        const isLocalHost = baseHost === 'localhost' || baseHost === '127.0.0.1';
        if (!isProxiHost && !isLocalHost) {
            // try to get the organization info by the base url
            try {
                this.urlOrganization = await getPublicOrganizationByDomain(baseUrl);
            } catch (e) {
                // if the organization is not found, then we will not set the organization
            }
        }
        this.isReady = true;
    }
}

const urlInfo = new UrlInfo();

export default urlInfo;
